<template>
  <div class="page">
    <el-card class="tableArea">
      <!-- 搜索 添加  -->
      <el-form :inline="true" ref="queryInfoRef" :model="queryInfo" class="demo-form-inline">
        <el-row>
            <el-form-item :label="$t('device.deviceImei')">
              <el-input v-model.trim="queryInfo.deviceImei" :placeholder="$t('devicePage.deviceImeiPlaceholder')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getDeviceList">{{$t('common.search')}}</el-button>
              <el-button type="warning" @click="resetQuery">{{$t('common.reset')}}</el-button>
            </el-form-item>
        </el-row>
      </el-form>
      <el-row>
        <el-button type="primary" @click="initAdd">{{$t('common.add')}}</el-button>
        <el-button type="warning" @click="importDevice">导入</el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="hasSelected"
          @click="handleDelete"
        >删除</el-button>
      </el-row>
      <!-- 用户列表区域 -->
      <el-table :data="deviceList" :border="true" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column type="index" :label="$t('common.sn')" fixed></el-table-column>
        <el-table-column prop="deviceId" type="deviceId" label="deviceId" v-if="false"></el-table-column>
        <el-table-column prop="deviceImei" :label="$t('device.deviceImei')" width="140px;" fixed></el-table-column>
        <el-table-column prop="onlineStatus" :label="$t('device.onlineStatus')" width="105px;" :formatter="deviceOnlineStatusFormatter" ></el-table-column>
        <el-table-column prop="lastLongitude" :label="$t('device.lastLongitude')" width="120px;"></el-table-column>
        <el-table-column prop="lastLatitude" :label="$t('device.lastLatitude')" width="120px;"></el-table-column>
        <el-table-column prop="lastLocationTime" :label="$t('device.lastLocationTime')" width="150px;"></el-table-column>
        <el-table-column prop="deviceRemark" :label="$t('device.deviceRemark')"></el-table-column>

        <!-- 操作  prop 中的元素 -->
        <el-table-column :label="$t('common.operation')" width="240px;">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              plain
              @click="showEditDialog(scope.row.deviceImei,scope.row.deviceRemark,scope.row.deviceId)"
            >修改
            </el-button>

            </template>

        </el-table-column>

      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pageNum"
        :page-sizes="[20, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 添加用户的对话框 -->
    <el-dialog :title="$t('devicePage.addDiagTitle')" :visible.sync="addDialogVisible" width="20%" @close="addDialogClosed">
      <!-- 内容主体 -->
      <el-form
        :model="addForm"
        ref="addFormRef"
        :rules="addFormRules"
        label-width="60px"
        label-position="right"
        class="addForm"
        size="mini"
      >
        <el-form-item :label="$t('device.deviceImei')" prop="deviceImei">
          <el-input v-model.trim="addForm.deviceImei"></el-input>
        </el-form-item>
        <el-form-item :label="$t('device.deviceRemark')">
          <el-input v-model.trim="addForm.deviceRemark" ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="addOrUpdate">{{$t('common.confirm')}}</el-button>
      </span>
    </el-dialog>

    <!-- TODO 新增的 修改 备注 弹窗 updateFormRef -->
    <el-dialog :title="$t('devicePage.addDiagTitle')" :visible.sync="updateDialogVisible" width="20%" @close="updateDialogClosed">
       <!-- 内容主体 -->
       <el-form
        :model="updateForm"
        ref="updateFormRef"
        :rules="updateFormRules"
        label-width="60px"
        label-position="right"
        class="addForm"
        size="mini"
      >
        <el-form-item :label="$t('device.deviceImei')" prop="deviceImei">
          <el-input v-model.trim="updateForm.deviceImei"></el-input>
        </el-form-item>
        <el-form-item :label="$t('device.deviceRemark')">
          <el-input v-model.trim="updateForm.deviceRemark" ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="updateOrUpdate">{{$t('common.confirm')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="importTemplate">下载模板</el-link>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { checkLogin } from '@/api/globalProcessErr'
import {
  getGpsDeviceById,
  listGpsDevice,
  updateGpsDevice,
  insertGpsDevice,
  deleteGpsDevice,
  getDeviceTankByDeviceId,
  updateDeviceTankConfig, batchDeleteGpsDevice, downloadImportTemplate
} from '@/api/gpsDevice'

import { listCodeByClass } from '@/api/code'
import { addMonth } from '@/api/dateFunc'
import { listDeptByCustomerId } from '@/api/sysDept'
import { getErrroDescStr } from '../../../api/enum'
import {exportUser} from "@/api/sysUser";
import axios from "axios";

export default {
  data () {
    let checkTimeZone = (rule, value, callback) => {
      if (isNaN(value) || value < -720 || value > 720) {
        return callback(new Error(this.$t('devicePage.rules.timeZone.validator') + ''))
      }
      return callback()
    }
    let checkBaseMileage = (rule, value, callback) => {
      if (isNaN(value) || value < 0) {
        return callback(new Error(this.$t('devicePage.rules.baseMileage.validator') + ''))
      }
      return callback()
    }
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() <= Date.now()
        },
        shortcuts: [{
          text: this.$t('devicePage.rules.expireDate.threeMonth'),
          onClick (picker) {
            const date = new Date()
            let newDate = addMonth(date, 3)
            picker.$emit('pick', newDate)
          }
        }, {
          text: this.$t('devicePage.rules.expireDate.sixMonth'),
          onClick (picker) {
            const date = new Date()
            let newDate = addMonth(date, 6)
            picker.$emit('pick', newDate)
          }
        }, {
          text: this.$t('devicePage.rules.expireDate.oneYear'),
          onClick (picker) {
            const date = new Date()
            let newDate = addMonth(date, 12)
            picker.$emit('pick', newDate)
          }
        }]
      },
      checkTimeZone: checkTimeZone,
      checkBaseMileage: checkBaseMileage,
      queryInfo: {
        deviceName: '',
        deviceImei: '',
        organization: '',
        bindMobile: '',
        deviceType: undefined,
        // 当前页数
        pageNum: 1,
        // 每页显示多少数据
        pageSize: 20
      },
      /*deviceTypeList: [
        this.$t('device.deviceTypeEnum.vehicleMountedLocator'),
        this.$t('device.deviceTypeEnum.pigeonLocator'),
        this.$t('device.deviceTypeEnum.studentCard'),
        this.$t('device.deviceTypeEnum.drivingRecorder')
      ],*/
      locationTypeList: [],
      deviceStatusList: [
        this.$t('device.deviceStatusEnum.online'),
        this.$t('device.deviceStatusEnum.offline')
      ],
      deviceColourList: [],
      deviceList: [],
      deptList: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户编辑对话框
      updateDialogVisible: false,
      tankDialogVisible: false,
      hasSelected: true,
      ids: '',
      // 用户添加
      addForm: {
        deviceId: undefined,
        deviceImei: '',
        deviceName: '',
        bindMobile: '',
        deviceType: 1,
        expireDate: '',
        timeZone: 0,
        baseMileage: 0,
        deviceRemark: '',
        deviceStatus: 1,
        deptId: undefined
      },
      //修改用户
      updateForm: {
        deviceId: undefined,
        deviceImei: '',
        deviceName: '',
        bindMobile: '',
        deviceType: 1,
        expireDate: '',
        timeZone: 0,
        baseMileage: 0,
        deviceRemark: '',
        deviceStatus: 1,
        deptId: undefined
      },
      tankForm: {
        deviceId: undefined,
        ad1Max: 0,
        ad1Min: 0,
        ad2Max: 0,
        ad2Min: 0,
        ad3Max: 0,
        ad3Min: 0,
        ad4Max: 0,
        ad4Min: 0
      },
      // 用户导入参数
      upload: {
        // 是否显示弹出层
        open: false,
        // 弹出层标题
        title: "设备导入",
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        headers: {
          'token': window.sessionStorage.getItem('token') || '',
          'clientFlag': 1,
          'session': window.sessionStorage.getItem('session') || '',
          'userId': window.sessionStorage.getItem('userId') || 0
        },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/gps/device/importDevice"
      },
    }
  },
  computed: {
    addFormRules () {
      return {
        deviceImei: [
          { required: true, message: this.$t('devicePage.rules.deviceImei.required'), trigger: 'blur' }
        ]
      }
    },
    updateFormRules () {
      return {
        deviceImei: [
          { required: true, message: this.$t('devicePage.rules.deviceImei.required'), trigger: 'blur' }
        ]
      }
    },

  },
  created () {
    this.$i18n.locale = window.sessionStorage.getItem('lang')
    this.getDeviceList()
    // this.getLocationTypeList()
    // this.getDeviceColourList()
    // this.listDept()
  },
  methods: {
    // TODO 弹窗修改对话框 备注 remark
    showEditDialog(deviceImei,remark,deviceId){
      // alert("数据是："+deviceImei)
      this.updateDialogVisible = true

      this.updateForm = {
        deviceId: deviceId,
        deviceImei: deviceImei,
        deviceRemark: remark
      }


      // this.addForm = {
      //   deviceId: undefined,
      //   deviceImei: '',
      //   deviceName: '',
      //   bindMobile: '',
      //   deviceType: 1,
      //   timeZone: 0,
      //   baseMileage: 0,
      //   deviceRemark: '',
      //   deviceStatus: 1,
      //   deptId: undefined,
      //   expireDate: ''
      // }


    },
    getDeviceList () {
      listGpsDevice(this.queryInfo).then(res => {
        checkLogin(res, this.$message)
        if (res.data.code === 0) {
          this.deviceList = res.data.data.list
          this.total = res.data.data.total || 0
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    listDept () {
      const self = this
      let customerId = parseInt(window.sessionStorage.getItem('selfCustomerId'))
      listDeptByCustomerId(customerId).then(res => {
        checkLogin(res)
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        self.deptList = res.data.data
        if (self.deptList.length === 1) {
          self.addForm.deptId = self.deptList[0].deptId
        }
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    handleOperation (data) {
      switch (data.cmd) {
        case 'edit':
          this.editDevice(data.deviceId)
          break
        case 'config':
          this.editDevicePortConfig(data.deviceId)
          break
        case 'tank':
          this.editTank(data.deviceId)
          break
        case 'remove':
          this.removeDevice(data.deviceId)
          break
        default:
      }
    },
    updateTank () {
      const self = this
      updateDeviceTankConfig(self.tankForm).then(res => {
        checkLogin(res)
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        self.$message.success(self.$t('common.updateSuccess'))
        self.tankDialogVisible = false
      }).catch(err => {
        self.$message.error(err.message)
      })
    },
    addOrUpdate () {
      const self = this
      self.$refs.addFormRef.validate(async valid => {
        // 表单预校验失败
        if (!valid) return
        if (self.addForm.deviceId === undefined) {
          const req = self.addForm
          insertGpsDevice(req).then(res => {
            if (res.data.code === 3008) {
              return self.$message.error(self.$t('devicePage.rules.insert.imeiExists'))
            }
            if (res.data.code === 3009) {
              return self.$message.error(self.$t('devicePage.rules.insert.nameExists'))
            }
            if (res.data.code !== 0) {
              return self.$message.error(res.data.msg)
            }
            self.$message.success(self.$t('common.createSuccess'))
            self.getDeviceList()
          }).catch(err => {
            return self.$message.error(err.message)
          })
        } else {
          updateGpsDevice(self.addForm).then(res => {
            if (res.data.code !== 0) {
              return self.$message.error(res.data.msg)
            }
            self.$message.success(self.$t('common.updateSuccess'))
            self.getDeviceList()
          }).catch(err => {
            return self.$message.error(err.message)
          })
        }
        // 隐藏添加用户对话框
        this.addDialogVisible = false
      })
    },
    // TODO 发请求更新数据
    updateOrUpdate () {
      const self = this
      self.$refs.updateFormRef.validate(async valid => {
        // 表单预校验失败
        if (!valid) return
        if (self.updateForm.deviceId === undefined) {
          const req = self.updateForm
          insertGpsDevice(req).then(res => {
            if (res.data.code === 3008) {
              return self.$message.error(self.$t('devicePage.rules.insert.imeiExists'))
            }
            if (res.data.code === 3009) {
              return self.$message.error(self.$t('devicePage.rules.insert.nameExists'))
            }
            if (res.data.code !== 0) {
              return self.$message.error(res.data.msg)
            }
            self.$message.success(self.$t('common.createSuccess'))
            self.getDeviceList()
          }).catch(err => {
            return self.$message.error(err.message)
          })
        } else {
          // updateGpsDevice
          updateGpsDevice(self.updateForm).then(res => {
            if (res.data.code !== 0) {
              return self.$message.error(res.data.msg)
            }
            self.$message.success(self.$t('common.updateSuccess'))
            self.getDeviceList()
          }).catch(err => {
            return self.$message.error(err.message)
          })
        }
        // 隐藏添加用户对话框
        this.updateDialogVisible = false
      })
    },
    async removeDevice (deviceId) {
      const self = this
      const confirmResult = await this.$confirm(
        self.$t('common.deleteConfirm'),
        self.$t('common.notice'),
        {
          confirmButtonText: self.$t('common.confirm'),
          cancelButtonText: self.$t('common.cancel'),
          type: 'warning'
        }
      ).catch(err => err)
      // 点击确定 返回值为：confirm
      // 点击取消 返回值为： cancel
      if (confirmResult !== 'confirm') {
        return this.$message.success(self.$t('common.canceled'))
      }
      deleteGpsDevice(deviceId).then(res => {
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.$message.info(self.$t('common.deleteSuccess'))
        this.getDeviceList()
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    getLocationTypeList () {
      listCodeByClass('LOCATION_TYPE').then(res => {
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.locationTypeList = res.data.data
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    getDeviceColourList () {
      listCodeByClass('DEVICE_COLOUR').then(res => {
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.deviceColourList = res.data.data
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    /*deviceTypeFormatter (row, column) {
      for (let i = 1; i < this.deviceTypeList.length; i++) {
        if (row.deviceType === i) {
          return this.deviceTypeList[i - 1]
        }
      }
    },*/
    deviceOnlineStatusFormatter (row, column) {
      if (row.onlineStatus) {
        return this.deviceStatusList[0]
      } else {
        return this.deviceStatusList[1]
      }
    },
    locationTypeFormatter (row, column) {
      for (let i = 0; i < this.locationTypeList.length; i++) {
        if (row.lastLocationType === parseInt(this.locationTypeList[i].codeValue)) {
          return this.locationTypeList[i].codeName
        }
      }
    },
    importDevice(){
      this.upload.open = true
    },
    /** 下载模板操作 */
    importTemplate() {
      downloadImportTemplate().then(res => {
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = Date.parse(new Date()) + '.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          // console.log(2)
          navigator.msSaveBlob(blob, fileName)
        } else {
          // console.log(3)
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
// 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>" + response.msg + "</div>", "导入结果", { dangerouslyUseHTMLString: true });
      this.getDeviceList();
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
    // 监听 pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.getDeviceList()
    },
    // 监听 页码值 改变事件
    handleCurrentChange (newSize) {
      this.queryInfo.pageNum = newSize
      this.getDeviceList()
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.deviceId)
      this.hasSelected = !selection.length
    },
    /** 删除按钮操作 */
    async handleDelete(row) {
      const deviceIds = row.deviceId || this.ids;
      const confirmResult = await this.$confirm(
        '此操作将永久删除所选设备, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      // 点击确定 返回值为：confirm
      // 点击取消 返回值为： cancel
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      batchDeleteGpsDevice(deviceIds).then(res =>{
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.$message.info('成功删除所选的设备')
        this.getDeviceList()
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 监听 添加对话框的关闭事件
    addDialogClosed () {
      this.$refs.addFormRef.resetFields()
    },
    // 监听 更新对话框的关闭事件
    updateDialogClosed () {
      this.$refs.updateFormRef.resetFields()
    },

    tankDialogClosed () {
      this.$refs.tankForm.resetFields()
    },
    initAdd () {
      this.addDialogVisible = true
      this.addForm = {
        deviceId: undefined,
        deviceImei: '',
        deviceName: '',
        bindMobile: '',
        deviceType: 1,
        timeZone: 0,
        baseMileage: 0,
        deviceRemark: '',
        deviceStatus: 1,
        deptId: undefined,
        expireDate: ''
      }
      this.listDept()
    },
    editDevice (deviceId) {
      const self = this
      getGpsDeviceById(deviceId).then(res => {
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        self.addForm = res.data.data
        self.addDialogVisible = true
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    editTank (deviceId) {
      const self = this
      getDeviceTankByDeviceId(deviceId).then(res => {
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        self.tankForm = res.data.data
        self.tankDialogVisible = true
      }).catch(err => {
        return self.$message.error(err.message)
      })
    },
    resetQuery () {
      // this.$refs['queryInfoRef'].resetFields()
      this.queryInfo.deviceImei = ''
      this.queryInfo.userName = ''
      this.queryInfo.deviceName = ''
      this.queryInfo.organization = ''
      this.queryInfo.bindMobile = ''
      this.queryInfo.deviceType = undefined
      this.pageNum = 1
      this.pageSize = 20
      this.getDeviceList()
    },
    editDevicePortConfig (deviceId) {
      window.sessionStorage.setItem('PortConfig:DeviceId', deviceId)
      this.$router.push({
        name: 'portConfig',
        params: {
          deviceId: deviceId
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-card {
  .el-form {
    .el-col {
      padding-left: 0 !important;
      padding-right: 0 !important;
      margin-right: 0 !important;
      margin-left: 0 !important;

      .el-form-item {
        font-size: xx-small;
        width: 260px;
        padding-left: 0;
        padding-right: 0;
        margin-left: 0;
        margin-right: 0;

        .el-input {
          width: 150px;
          margin-right: 0;
          margin-left: 0;
        }
      }

      .el-select {
        width: 150px;
      }
    }
  }
}

.el-dialog {
  .el-form {
    width: 100% !important;

    .el-row {
      .el-col {
        .el-input {
          width: 150px;
        }

        .el-select {
          width: 150px;
        }
      }
    }
  }
}

.el-table {
  .el-table-column {
  }
}

.tableArea {
  padding-right: 0 !important;
  padding-left: 0 !important;
  width: 95% !important;
}

.page {
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}

.noBoard {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}

.addForm {
  width: 650px !important;
}

.operation {
  color: #108cf8 !important;
}

.tankClass {
  width: 100px !important;
  margin-left: 0!important;
}

</style>
